"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invisible = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const invisible_style_1 = __importDefault(require("./invisible.style"));
class Invisible extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            if (this.props.visible)
                return this.props.children;
            return jsx_runtime_1.jsx("div", Object.assign({ className: this.props.classes.root }, { children: this.props.children }), void 0);
        };
    }
}
exports.Invisible = Invisible;
Invisible.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    visible: prop_types_1.default.bool
};
Invisible.defaultProps = {
    visible: false
};
exports.default = react_jss_1.default(invisible_style_1.default)(Invisible);
//# sourceMappingURL=invisible.js.map